import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/addModalSlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  driveSchoolFetch,
  fetchDataCategories,
} from "../../store/slices/apiCategorySlice";
import Select from "react-select";
import {
  createDataCards,
  fetchDataCard,
} from "../../store/slices/apiCardSlice";

const AddModalPackage = ({ title, submitButtonText, onCardCreated }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.addModal.isOpen);

  const [packageName, setPackageName] = useState("");
  const [adminPrice, setAdminPrice] = useState("");
  const [schoolPrice, setSchoolPrice] = useState("");
  const [status, setStatus] = useState("");
  const [days1, setDays] = useState("");
  const [driveSchool, setDriveSchool] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState(null);

  const categoryOptions = useSelector((state) => state.apiCategory.data);
  const driveSchoolOptions = useSelector(
    (state) => state.apiCategory.driveSchool
  );

  const [schoolIsActive, setSchoolIsActive] = useState(false);

  useEffect(() => {
    dispatch(fetchDataCategories());
    dispatch(driveSchoolFetch());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedCategoryId = selectedOption ? selectedOption.value : null;
    const selectedOptionSchool = selectedSchool ? selectedSchool.value : null;

    const data = {
      code: packageName,
      cat_id: selectedCategoryId,
      adminPrice: adminPrice,
      schoolPrice: schoolPrice,
      status: schoolIsActive ? 1 : 0,
      days: days1,
      driveSchool_id: selectedOptionSchool,
    };
    try {
      await dispatch(createDataCards(data));
      setPackageName("");
      setSelectedOption(null);
      setSelectedSchool(null);
      handleCloseModal();
      setStatus("");
      setDays("");
      setAdminPrice("");
      setSchoolPrice("");
      setDriveSchool("");
      toast.success("Testi u shtua me sukses !");
      if (onCardCreated) {
        onCardCreated();
      }
      dispatch(fetchDataCard());
    } catch (error) {
      console.log("Error submitting data:", error);
    }
  };

  const handleOpenModal = () => {
    dispatch(openModal());
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleSchoolChange = (selectedSchool) => {
    setSelectedSchool(selectedSchool);
  };

  return (
    <div>
      <button
        onClick={handleOpenModal}
        className="text-white bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-blue-500 text-sm font-medium px-4 py-2 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-600"
      >
        Shto Kodin
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>

          <div className="relative w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg z-10 overflow-hidden">
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark className="w-5 h-5" />
            </button>

            <div className="p-5 sm:p-6 text-center">
              <h3 className="mb-4 text-lg sm:text-xl font-semibold text-gray-700 dark:text-gray-300">
                {title}
              </h3>

              <form className="space-y-4 text-left" onSubmit={handleSubmit}>
                <div>
                  <label
                    htmlFor="input1"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Kodi:
                  </label>
                  <input
                    type="text"
                    id="input1"
                    value={packageName}
                    onChange={(e) => setPackageName(e.target.value)}
                    required
                    className="w-full p-2.5 text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-900 dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                  />
                </div>

                <div>
                  <label
                    htmlFor="input2"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Zgjedh kategorinë:
                  </label>
                  <Select
                    isClearable
                    id="input2"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    options={categoryOptions.map((option) => ({
                      value: option.id,
                      label: option.name,
                    }))}
                  />
                </div>

                <div>
                  <label
                    htmlFor="adminPrice"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Çmimi i kartelës - admin:
                  </label>
                  <input
                    type="text"
                    id="adminPrice"
                    value={adminPrice}
                    onChange={(e) => setAdminPrice(e.target.value)}
                    required
                    className="w-full p-2.5 text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-900 dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                  />
                </div>

                <div>
                  <label
                    htmlFor="schoolPrice"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Çmimi i kartelës - autoshkollë:
                  </label>
                  <input
                    type="text"
                    id="schoolPrice"
                    value={schoolPrice}
                    onChange={(e) => setSchoolPrice(e.target.value)}
                    required
                    className="w-full p-2.5 text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-900 dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                  />
                </div>

                <div>
                  <label
                    htmlFor="days1"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Ditët e abonimit:
                  </label>
                  <input
                    type="number"
                    id="days1"
                    value={days1}
                    onChange={(e) => setDays(e.target.value)}
                    required
                    className="w-full p-2.5 text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-gray-900 dark:bg-gray-600 dark:border-gray-500 dark:text-white"
                  />
                </div>

                <div>
                  <label
                    htmlFor="school"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Autoshkolla:
                  </label>
                  <Select
                    isClearable
                    id="school"
                    value={selectedSchool}
                    onChange={handleSchoolChange}
                    options={(driveSchoolOptions || []).map((option) => ({
                      value: option.id,
                      label: option.name,
                    }))}
                  />
                </div>

                <div className="flex flex-col sm:flex-row justify-center gap-3 pt-4">
                  <button
                    type="submit"
                    className="w-full sm:w-auto text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
                  >
                    {submitButtonText}
                  </button>
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="w-full sm:w-auto text-gray-700 bg-white hover:bg-gray-100 border border-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-600 dark:text-gray-300 dark:border-gray-500 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    Anulo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default AddModalPackage;
